



















































































import { UserEntity } from "@/models/userEntity";
import { AddressEntity } from "@/models/addressEntity";
import { ContactEntity } from "@/models/contactEntity";
import { UserModule } from "@/store/modules/user.store";
import { Component, Vue } from "vue-property-decorator";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";

@Component
export default class ProfileCard extends Vue {
  debug = this.$store.state.config.debug;
  ActionEnum = ActionEnum;
  ResourceEnum = ResourceEnum;

  get user(): UserEntity {
    return UserModule.user;
  }

  get contact(): ContactEntity {
    return UserModule.user.contact || ({ email: "", phone: "" } as ContactEntity);
  }

  get address(): AddressEntity {
    return UserModule.user.address || ({} as AddressEntity);
  }

  logout() {
    UserModule.logout();
  }

  goBack() {
    this.$router.go(-1);
  }

  edit() {
    this.$router.push({ name: "ProfileEdit" });
  }

  goToPermissions() {
    this.$router.push({ name: "Permissions" });
  }
}
